module.exports = __webpack_public_path__ + "static/leader1-45f48ee5f0fdf566ea1b75fb5fbad783.jpg";